<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-book-reader"></i> {{entityName | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="designerForm">
      <!--    TODO Begin form here-->
      <div class="row mb-2">
        <div class="col-md-2 custom-legend">
          <h6 class="align-middle delete-margin">{{ "TITLE.TEST-FILE" | translate }}</h6>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 padding-select-file">
          <div class="custom-file content-file">
            <input type="file"
                   class="custom-file-input"
                   accept="application/pdf"
                   alife-file-to-base64
                   id="customTestFile"
                   (onFileChanged)="changeStatus2($event)">
            <div class="custom-file-label">
              <label for="customTestFile">
                {{designerForm.get('testFilename2Show').value ? designerForm.get('testFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 custom-legend">
          <h6 class="align-middle delete-margin">{{ "TITLE.LEGENDS" | translate }}</h6>
        </div>
        <div class="col">
          <button type="button" class="btn btn-success btn-sm float-right" (click)="addRowLegend()">
            + {{ "BUTTON.ADD" | translate }}</button>
          <label class="float-right" style="color: #7fba5c;">
            <a class="mr-2 ml-2" href="javascript:"
               (click)="viewParams()">
              <i class="fa fa-eye"></i> {{ "BUTTON.VIEW-PARAMETERS" | translate }}</a>
          </label>
        </div>
      </div>
      <div class="mt-1 scrollable">
        <div class="table-responsive">
          <table class="table-sm table-bordered">
            <thead class="thead-dark">
            <tr>
              <th scope="col" class="width-th-1">#</th>
              <th scope="col" class="width-th-2">{{ "TABLE.HEADER.DESCRIPTION" | translate }}</th>
              <th scope="col" class="width-th-3">Horiz.</th>
              <th scope="col" class="width-th-3">Vertic.</th>
              <th scope="col" class="width-th-3">{{ "TABLE.HEADER.ROTATION" | translate }}</th>
              <th scope="col" class="width-th-3">{{ "TABLE.HEADER.SIZE" | translate }}</th>
              <th scope="col" class="width-th-4">{{ "TABLE.HEADER.TYPE" | translate }}</th>
              <th scope="col" class="width-th-4">Color</th>
              <th scope="col" class="width-th-5">{{ "TABLE.HEADER.STAMPED" | translate }}</th>
              <th scope="col" class="width-th-3">{{ "TABLE.HEADER.PAGE" | translate }}</th>
              <th scope="col" class="width-th-1" [hidden]="false">{{ "TABLE.HEADER.ACTION" | translate }}
              </th>
            </tr>
            </thead>
            <tbody formArrayName="arrayLegend">
            <tr *ngFor="let group of arrayLegend.controls; let index= index" [formGroupName]="index">
              <td>{{ index + 1}}</td>
              <td>
                <input type="text"
                       class="form-control width-th-2"
                       formControlName="descriptionLegend"
                       [class.is-invalid]="isInvalidControl('arrayLegend', index, 'descriptionLegend')">
                <small *ngIf="isInvalidControl('arrayLegend', index, 'descriptionLegend')"
                       class="text-danger">
                  {{ "MESSAGE.REQUIRED-FIELD" | translate }}
                </small>
              </td>
              <td title="Horiz.">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="positionXLegend"
                       [class.is-invalid]="isInvalidControl('arrayLegend',index, 'positionXLegend')">
                <small *ngIf="isInvalidControl('arrayLegend', index, 'positionXLegend')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="Vertic.">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="positionYLegend"
                       [class.is-invalid]="isInvalidControl('arrayLegend', index, 'positionYLegend')">
                <small *ngIf="isInvalidControl('arrayLegend', index, 'positionYLegend')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="{{ 'TABLE.HEADER.ROTATION' | translate }}">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="rotationLegend"
                       [class.is-invalid]="isInvalidControl('arrayLegend',index, 'rotationLegend')">
                <small *ngIf="isInvalidControl('arrayLegend', index, 'rotationLegend')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="{{ 'TABLE.HEADER.SIZE' | translate }}">
                <select class="form-control width-th-3"
                        formControlName="fontsize">
                  <option *ngFor="let fontsize of fontsizes" [ngValue]="fontsize">{{fontsize.size}}</option>
                </select>
              </td>
              <td title="{{ 'TABLE.HEADER.TYPE' | translate }}">
                <select class="form-control width-th-4"
                        formControlName="fonttype">
                  <option *ngFor="let fonttype of fonttypes"
                          [ngValue]="fonttype">{{fonttype.description | translate}}</option>
                </select>
              </td>
              <td title="Color">
                <input formControlName="fontRgbColor"
                       style="color:{{ getColor(index) }};"
                       class="form-control width-th-4"
                       [style.background]="getColor(index)"
                       [cpAlphaChannel]="'always'"
                       [cpOutputFormat]="'rgba'"
                       [cpPresetColors]="['#fff', '#2889e9']"
                       [cpAddColorButton]="true"
                       [(colorPicker)]="color"
                       (colorPickerChange)="colorPickerChange(index, $event)"/>
              </td>
              <td title="{{ 'TABLE.HEADER.STAMPED' | translate }}">
                <select class="form-control width-th-5"
                        formControlName="pagestampLegend"
                        (ngModelChange)="onChangeStamp(group, 'pagestampLegend','stampOnLegend')">
                  <option *ngFor="let pagestamp of pagestamps"
                          [ngValue]="pagestamp">{{pagestamp.description | translate}}</option>
                </select>
              </td>
              <td title="{{ 'TABLE.HEADER.PAGE' | translate }}">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="stampOnLegend"
                       [class.is-invalid]="isInvalidControl('arrayLegend',index, 'stampOnLegend')"
                       [attr.disabled]="optionSelectedBy(group, 'pagestampLegend') ? null : ''">
                <small *ngIf="isInvalidControl('arrayLegend', index, 'stampOnLegend')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td class="text-center" [hidden]="false" title="{{ 'TABLE.HEADER.ACTION' | translate }}">
                <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteLegendRow(index)"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br>
      <div class="row mt-1">
        <div class="col-md-2 custom-legend">
          <h6 class="align-middle delete-margin">{{ "TITLE.IMAGES" | translate }}</h6>
        </div>
        <div class="col">
          <button type="button" class="btn btn-success btn-sm float-right" (click)="addRowImage()">
            + {{ "BUTTON.ADD" | translate }}</button>
        </div>
      </div>
      <div class="mt-1 scrollable ">
        <div class="table-responsive">
          <table class="table-sm table-bordered">
            <thead class="thead-dark">
            <tr>
              <th scope="col" class="width-th-1">#</th>
              <th scope="col" class="width-th-7">{{ "TABLE.HEADER.FILE" | translate }}</th>
              <th scope="col" class="width-th-3">Horiz.</th>
              <th scope="col" class="width-th-3">Vertic.</th>
              <th scope="col" class="width-th-3">{{ "TABLE.HEADER.PERCENT" | translate }}</th>
              <th scope="col" class="width-th-3">{{ "TABLE.HEADER.ROTATION" | translate }}</th>
              <th scope="col" class="width-th-5">{{ "TABLE.HEADER.POSITION" | translate }}</th>
              <th scope="col" class="width-th-5">{{ "TABLE.HEADER.STAMPED" | translate }}</th>
              <th scope="col" class="width-th-3">{{ "TABLE.HEADER.PAGE" | translate }}</th>
              <th scope="col" class="width-th-1" [hidden]="false">{{ "TABLE.HEADER.ACTION" | translate }}
              </th>
            </tr>
            </thead>
            <tbody formArrayName="arrayImage">
            <tr *ngFor="let group of arrayImage.controls; let index = index" [formGroupName]="index">
              <td title="#" class="font-weight-bold">{{ index + 1}}</td>
              <td title="{{ 'TABLE.HEADER.FILE' | translate }}">
                <div class="col padding-select-file content-file" style="padding-left: 0;">
                  <div class="custom-file content-file">
                    <input type="file"
                           id="inputImage"
                           class="custom-file-input"
                           accept="image/jpeg, image/png"
                           alife-file-to-base64
                           (onFileChanged)="changeStatus($event, index)"
                           [class.is-invalid]="isInvalid(group, 'fileBase64Image')">
                    <div class="custom-file-label">
                      <label class="mr-260">
                        {{group.get('filename2ShowImage').value ? group.get('filename2ShowImage').value : ('MESSAGE.SELECT' | translate)}}
                      </label>
                    </div>
                  </div>
                </div>
                <small *ngIf="isInvalid(group, 'fileBase64Image')"
                       class="text-danger">
                  {{ "MESSAGE.REQUIRED-FIELD" | translate }}
                </small>
              </td>
              <td title="Horiz.">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="positionXImage"
                       [class.is-invalid]="isInvalidControl('arrayImage', index, 'positionXImage')">
                <small *ngIf="isInvalidControl('arrayImage', index, 'positionXImage')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="Vertic.">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="positionYImage"
                       [class.is-invalid]="isInvalidControl('arrayImage', index, 'positionYImage')">
                <small *ngIf="isInvalidControl('arrayImage', index, 'positionYImage')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="{{ 'TABLE.HEADER.PERCENT' | translate }}">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="percentSizeImage"
                       [class.is-invalid]="isInvalidControl('arrayImage',index, 'percentSizeImage')">
                <small *ngIf="isInvalidControl('arrayImage', index, 'percentSizeImage')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="{{ 'TABLE.HEADER.ROTATION' | translate }}">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="rotationImage"
                       [class.is-invalid]="isInvalidControl('arrayImage', index, 'rotationImage')">
                <small *ngIf="isInvalidControl('arrayImage', index, 'rotationImage')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="{{ 'TABLE.HEADER.POSITION' | translate }}">
                <select class="form-control"
                        formControlName="contentpositionImage">
                  <option *ngFor="let contentposition of contentpositions"
                          [ngValue]="contentposition">{{contentposition.description | translate}}</option>
                </select>
              </td>
              <td title="{{ 'TABLE.HEADER.STAMPED' | translate }}">
                <select class="form-control"
                        formControlName="pagestampImage"
                        (ngModelChange)="onChangeStamp(group, 'pagestampImage','stampOnImage')">
                  <option *ngFor="let pagestamp of pagestamps"
                          [ngValue]="pagestamp">{{pagestamp.description | translate}}</option>
                </select>
              </td>
              <td title="{{ 'TABLE.HEADER.PAGE' | translate }}">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="stampOnImage"
                       [class.is-invalid]="isInvalidControl('arrayImage', index, 'stampOnImage')"
                       [attr.disabled]="optionSelectedBy(group, 'pagestampImage') ? null : ''">
                <small *ngIf="isInvalidControl('arrayImage', index, 'stampOnImage')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td class="text-center" [hidden]="false" title="{{ 'TABLE.HEADER.ACTION' | translate }}">
                <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteImageRow(index)"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br>
      <div class="row mt-1">
        <div class="col-md-2 custom-legend">
          <h6 class="align-middle delete-margin">{{ "TITLE.QR-CODE" | translate }}</h6>
        </div>
        <div class="col">
          <button type="button" class="btn btn-success btn-sm float-right" (click)="addRowQrcode()">
            + {{ "BUTTON.ADD" | translate }}</button>
        </div>
      </div>
      <div class="mt-1 scrollable">
        <div class="table-responsive">
          <table class="table-sm table-bordered">
            <thead class="thead-dark">
            <tr>
              <th scope="col" class="width-th-1">#</th>
              <th scope="col" class="width-th-2"></th>
              <th scope="col" class="width-th-3">Horiz.</th>
              <th scope="col" class="width-th-3">Vertic.</th>
              <th scope="col" class="width-th-3">{{ "TABLE.HEADER.SIZE" | translate }}</th>
              <th scope="col" class="width-th-5">{{ "TABLE.HEADER.STAMPED" | translate }}</th>
              <th scope="col" class="width-th-3">{{ "TABLE.HEADER.PAGE" | translate }}</th>
              <th scope="col" class="width-th-1" [hidden]="false">{{ "TABLE.HEADER.ACTION" | translate }}
              </th>
            </tr>
            </thead>
            <tbody formArrayName="arrayQrcode">
            <tr *ngFor="let group of arrayQrcode.controls; let index= index" [formGroupName]="index">
              <td title="#">{{ index + 1}}</td>
              <td title="">
                <label class="width-th-2"></label>
              </td>
              <td title="Horiz.">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="positionXQrcode"
                       [class.is-invalid]="isInvalidControl('arrayQrcode', index, 'positionXQrcode')">
                <small *ngIf="isInvalidControl('arrayQrcode', index, 'positionXQrcode')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="Vertic.">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="positionYQrcode"
                       [class.is-invalid]="isInvalidControl('arrayQrcode', index, 'positionYQrcode')">
                <small *ngIf="isInvalidControl('arrayQrcode', index, 'positionYQrcode')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="{{ 'TABLE.HEADER.SIZE' | translate }}">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="sideSizeQrcode"
                       [class.is-invalid]="isInvalidControl('arrayQrcode', index, 'sideSizeQrcode')">
                <small *ngIf="isInvalidControl('arrayQrcode', index, 'sideSizeQrcode')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td title="{{ 'TABLE.HEADER.STAMPED'| translate }}">
                <select class="form-control width-th-5"
                        formControlName="pagestampQrcode"
                        (ngModelChange)="onChangeStamp(group, 'pagestampQrcode', 'stampOnQrcode')">
                  <option *ngFor="let pagestamp of pagestamps"
                          [ngValue]="pagestamp">{{pagestamp.description | translate}}</option>
                </select>
              </td>
              <td title="{{ 'TABLE.HEADER.PAGE' | translate }}">
                <input type="text"
                       class="form-control width-th-3"
                       formControlName="stampOnQrcode"
                       [class.is-invalid]="isInvalidControl('arrayQrcode', index, 'stampOnQrcode')"
                       [attr.disabled]="optionSelectedBy(group, 'pagestampQrcode') ? null : ''">
                <small *ngIf="isInvalidControl('arrayQrcode', index, 'stampOnQrcode')"
                       class="text-danger">
                  {{ "MESSAGE.INVALID" | translate }}
                </small>
              </td>
              <td class="text-center" [hidden]="false" title="{{ 'TABLE.HEADER.ACTION' | translate }}">
                <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteQrcodeRow(index)"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="hasDigitalSignature && !hasParticipantWithDragRubric">
        <div class="row mt-1">
          <div class="col-md-2 custom-legend">
            <h6 class="align-middle delete-margin">{{ "TITLE.DATE-TIME" | translate }}</h6>
          </div>
          <div class="col">
            <button type="button" class="btn btn-success btn-sm float-right" (click)="addRowDatetime()">
              + {{ "BUTTON.ADD" | translate }}</button>
          </div>
        </div>
        <div class="mt-1 scrollable">
          <div class="table-responsive">
            <table class="table-sm table-bordered">
              <thead class="thead-dark">
              <tr>
                <th scope="col" class="width-th-1">#</th>
                <th scope="col" class="width-th-2">{{ "TABLE.HEADER.DESCRIPTION" | translate }}</th>
                <th scope="col" class="width-th-3">Horiz.</th>
                <th scope="col" class="width-th-3">Vertic.</th>
                <th scope="col" class="width-th-3">{{ "TABLE.HEADER.WIDTH" | translate }}</th>
                <th scope="col" class="width-th-3">{{ "TABLE.HEADER.HIGH" | translate }}</th>
                <th scope="col" class="width-th-5">{{ "TABLE.HEADER.STAMPED" | translate }}</th>
                <th scope="col" class="width-th-3">{{ "TABLE.HEADER.PAGE" | translate }}</th>
                <th scope="col" class="width-th-1" [hidden]="false">{{ "TABLE.HEADER.ACTION" | translate }}
                </th>
              </tr>
              </thead>
              <tbody formArrayName="arrayDatetime">
              <tr *ngFor="let group of arrayDatetime.controls; let index= index" [formGroupName]="index">
                <td title="#">1</td>
                <td title="{{ 'TABLE.HEADER.DESCRIPTION' | translate }}">
                  <input type="text"
                         class="form-control width-th-2"
                         formControlName="descriptionDatetime"
                         [class.is-invalid]="isInvalidControl('arrayDatetime', index, 'descriptionDatetime')">
                  <small *ngIf="isInvalidControl('arrayDatetime', index, 'descriptionDatetime')"
                         class="text-danger">
                    {{ "MESSAGE.REQUIRED-FIELD" | translate }}
                  </small>
                </td>
                <td title="{{ 'Horiz.' | translate }}">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="positionXDatetime"
                         [class.is-invalid]="isInvalidControl('arrayDatetime',index, 'positionXDatetime')">
                  <small *ngIf="isInvalidControl('arrayDatetime', index, 'positionXDatetime')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="{{ 'Vertic.' | translate }}">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="positionYDatetime"
                         [class.is-invalid]="isInvalidControl('arrayDatetime',index, 'positionYDatetime')">
                  <small *ngIf="isInvalidControl('arrayDatetime', index, 'positionYDatetime')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="{{ 'TABLE.HEADER.WIDTH' | translate }}">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="widthContainerDatetime"
                         [class.is-invalid]="isInvalidControl('arrayDatetime',index, 'widthContainerDatetime')">
                  <small *ngIf="isInvalidControl('arrayDatetime', index, 'widthContainerDatetime')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="{{ 'TABLE.HEADER.HIGH' | translate }}">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="heightContainerDatetime"
                         [class.is-invalid]="isInvalidControl('arrayDatetime', index, 'heightContainerDatetime')">
                  <small *ngIf="isInvalidControl('arrayDatetime', index, 'heightContainerDatetime')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="{{ 'TABLE.HEADER.STAMPED' | translate }}">
                  <select class="form-control width-th-5"
                          formControlName="pagestampDatetime"
                          (ngModelChange)="onChangeStamp(group, 'pagestampDatetime','stampOnDatetime' )">
                    <option *ngFor="let pagestamp of pagestamps4Datetime"
                            [ngValue]="pagestamp">{{pagestamp.description | translate}}</option>
                  </select>
                </td>
                <td title="{{ 'TABLE.HEADER.PAGE' | translate }}">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="stampOnDatetime"
                         [class.is-invalid]="isInvalidControl('arrayDatetime',index, 'stampOnDatetime')"
                         [attr.disabled]="optionSelectedBy(group, 'pagestampDatetime') ? null : ''">
                  <small *ngIf="isInvalidControl('arrayDatetime', index, 'stampOnDatetime')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td class="text-center" [hidden]="false" title="{{ 'TABLE.HEADER.ACTION' | translate }}">
                  <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteDatetimeRow(index)"></i>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mb-2" *ngIf="requireJasperTemplate">
        <div class="col-md-6 custom-legend">
          <h6 class="align-middle delete-margin">{{ "TITLE.TEMPLATE" | translate }}</h6>
        </div>
        <div class="col-md-6 custom-legend">
          <h6 class="align-middle delete-margin">{{ "TITLE.DATA-FILE" | translate }}</h6>
        </div>
      </div>
      <div class="row" *ngIf="requireJasperTemplate">
        <div class="col-md-6 padding-select-file">
          <div class="custom-file content-file">
            <input type="file"
                   class="custom-file-input"
                   accept=".jasper"
                   alife-file-to-base64
                   id="customLayoutFile"
                   (onFileChanged)="changeStatus3($event)">
            <div class="custom-file-label">
              <label for="customLayoutFile">
                {{designerForm.get('layoutFilename2Show').value ? designerForm.get('layoutFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-6 padding-select-file">
          <div class="custom-file content-file">
            <input type="file"
                   class="custom-file-input"
                   accept=".xml, .xls, .xlsx"
                   alife-file-to-base64
                   id="customLayoutFile2"
                   (onFileChanged)="changeStatus4($event)">
            <div class="custom-file-label">
              <label for="customLayoutFile2">
                {{designerForm.get('excelLayoutFilename2Show').value ? designerForm.get('excelLayoutFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isNotDynamicWorkFlow && !extractCoordinates">
        <br>
        <div class="row">
          <div class="col-md-2 custom-legend">
            <h6 class="align-middle delete-margin">{{ "TITLE.RUBRICS" | translate }}</h6>
          </div>
          <div class="col">
            <button type="button" class="btn btn-success btn-sm float-right"
                    (click)="addRowRubricParticipant()"
                    [disabled]="participantsIsFull">+ {{ "BUTTON.ADD" | translate }}
            </button>
          </div>
        </div>
        <div class="mt-1 scrollable">
          <div class="table-responsive">
            <table class="table-sm table-bordered">
              <thead class="thead-dark">
              <tr>
                <th scope="col" class="width-th-1">#</th>
                <th scope="col" class="width-th-7">{{ "TABLE.HEADER.PARTICIPANT" | translate }}</th>
                <th scope="col" class="width-th-3">Horiz.1</th>
                <th scope="col" class="width-th-3">Vertic.1</th>
                <th scope="col" class="width-th-3">Horiz.f</th>
                <th scope="col" class="width-th-3">Vertic.f</th>
                <th scope="col" class="width-th-3">{{ "TABLE.HEADER.PERCENT" | translate }}</th>
                <th scope="col" class="width-th-3">{{ "TABLE.HEADER.ROTATION" | translate }}</th>
                <th scope="col" class="width-th-5">{{ "TABLE.HEADER.POSITION" | translate }}</th>
                <th scope="col" class="width-th-5">{{ "TABLE.HEADER.STAMPED" | translate }}</th>
                <th scope="col" class="width-th-3">{{ "TABLE.HEADER.PAGE" | translate }}</th>
                <th scope="col" class="width-th-1">{{ "TABLE.HEADER.DUPLICATE" | translate }}</th>
                <th scope="col" class="width-th-1">{{ "TABLE.HEADER.ACTION" | translate }}
                </th>
              </tr>
              </thead>
              <tbody formArrayName="arrayRubricParticipant">
              <tr *ngFor="let group of arrayRubricParticipant.controls; let index = index" [formGroupName]="index">
                <td title="#">{{ index + 1}}</td>
                <td title="{{ 'TABLE.HEADER.PARTICIPANT' | translate }}">
                  <select class="form-control ml-1 mr-2 custom-width-select" formControlName="participantId"
                          [class.is-invalid]="existSeletedParticipant(index)"
                          [attr.disabled]="!hasStampRubricsCopy(index) ? null : ''"
                          [hidden]="isOriginalParticipant(index)"
                          (change)="setUpPersonIdValueAndValidations(group)">
                    <option *ngFor="let participant of participants"
                            [disabled]="isParticipantSelected(participant.id)"
                            [ngValue]="participant.id">{{participant._more.personFullName | translate}}</option>
                  </select>
                  <small *ngIf="existSeletedParticipant(index)"
                         class="text-danger">
                    {{ "MESSAGE.PARTICIPANT-HAS-ALREADY-SELECT" | translate }}
                  </small>
                </td>
                <td title="Horiz.1">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="positionXRubric"
                         [class.is-invalid]="isInvalidControl('arrayRubricParticipant',index, 'positionXRubric')">
                  <small *ngIf="isInvalidControl('arrayRubricParticipant', index, 'positionXRubric')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="Vertic.1">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="positionYRubric"
                         [class.is-invalid]="isInvalidControl('arrayRubricParticipant',index, 'positionYRubric')">
                  <small *ngIf="isInvalidControl('arrayRubricParticipant', index, 'positionYRubric')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="Horiz.f">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="positionXfRubric"
                         [class.is-invalid]="isInvalidControl('arrayRubricParticipant', index, 'positionXfRubric')"
                         [attr.disabled]="pendingPersonSelected(group) ? null : ''">
                  <small *ngIf="isInvalidControl('arrayRubricParticipant', index, 'positionXfRubric')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="Vertic.f">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="positionYfRubric"
                         [class.is-invalid]="isInvalidControl('arrayRubricParticipant', index, 'positionYfRubric')"
                         [attr.disabled]="pendingPersonSelected(group) ? null : ''">
                  <small *ngIf="isInvalidControl('arrayRubricParticipant', index, 'positionYfRubric')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="{{ 'TABLE.HEADER.PERCENT' | translate }}">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="percentSizeRubric"
                         [class.is-invalid]="isInvalidControl('arrayRubricParticipant', index, 'percentSizeRubric')"
                         [attr.disabled]="!pendingPersonSelected(group) ? null : ''">
                  <small *ngIf="isInvalidControl('arrayRubricParticipant', index, 'percentSizeRubric')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="{{ 'TABLE.HEADER.ROTATION' | translate }}">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="rotationRubric"
                         [class.is-invalid]="isInvalidControl('arrayRubricParticipant', index, 'rotationRubric')">
                  <small *ngIf="isInvalidControl('arrayRubricParticipant', index, 'rotationRubric')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td title="{{ 'TABLE.HEADER.POSITION' | translate }}">
                  <select class="form-control"
                          formControlName="contentpositionRubric">
                    <option *ngFor="let contentposition of contentpositions"
                            [ngValue]="contentposition">{{contentposition.description | translate}}</option>
                  </select>
                </td>
                <td title="{{ 'TABLE.HEADER.STAMPED' | translate }}">
                  <select class="form-control"
                          formControlName="pagestampRubric"
                          (ngModelChange)="onChangeStamp(group, 'pagestampRubric','stampOnRubric')">
                    <option *ngFor="let pagestamp of getPagestampsBy(index)"
                            [ngValue]="pagestamp">{{pagestamp.description | translate}}</option>
                  </select>
                </td>
                <td title="{{ 'TABLE.HEADER.PAGE' | translate }}">
                  <input type="text"
                         class="form-control width-th-3"
                         formControlName="stampOnRubric"
                         [class.is-invalid]="isInvalidControl('arrayRubricParticipant', index, 'stampOnRubric')"
                         [attr.disabled]="optionSelectedBy(group,'pagestampRubric') ? null : ''">
                  <small *ngIf="isInvalidControl('arrayRubricParticipant', index, 'stampOnRubric')"
                         class="text-danger">
                    {{ "MESSAGE.INVALID" | translate }}
                  </small>
                </td>
                <td class="text-center" title="{{ 'TABLE.HEADER.DUPLICATE' | translate }}">
                  <i class="fa fa-plus mt-2" [routerLink]=""
                     [hidden]="isOriginalParticipant(index) || existSeletedParticipant(index) || isSignCloud(index) || hasDragRubric(index)"
                     (click)="addRowRubricParticipant1(index)"> </i>
                </td>
                <td class="text-center" [hidden]="false" title="{{ 'TABLE.HEADER.ACTION' | translate }}">
                  <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteParticipantRow(index)"
                     [hidden]="hasStampRubricsCopy(index)"></i>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
    <!--    TODO End form here-->
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-info"
            (click)="preview()">
      <i class="fas fa-eye"></i> {{ "BUTTON.PREVIEW" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
